import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Button from "kpc/components/button";
import Icon from "kpc/components/icon";
import Tooltip from "kpc/components/tooltip";
import Checkbox from "kpc/components/checkbox";
import * as _ from "lodash";

export interface FilterItem {
    title: string;
    key: string;
    width: string | number;
    alwaysCheck: boolean;
    defaultCheck: boolean;
}

@Component({
    components: {
        Button,
        Icon,
        Tooltip,
        Checkbox
    }
})
export default class ColsFilter extends Vue {
    @Prop({
        required: false,
        default: ""
    })
    name!: string;

    @Prop({
        required: true,
        default: () => {}
    })
    cols!: any;

    checkedKeys: string[] = [];

    // cols:FilterItem[] = []

    // initDone:boolean = false;

    get allChecked() {
        // console.log(this.checkedKeys.length, _.keys(this.cols).length)
        // console.log(this.checkedKeys, this.checkedKeys.length, _.keys(this.cols).length, 1111);
        return this.checkedKeys.length === _.keys(this.cols).length;
    }

    get indeterminate() {
        // console.log(this.checkedKeys.length > 0 && this.checkedKeys.length < _.keys(this.cols).length, this.checkedKeys.length, _.keys(this.cols).length)
        return (
            this.checkedKeys.length > 0 &&
            this.checkedKeys.length < _.keys(this.cols).length
        );
    }

    get listOfCols() {
        let alwaysCheckedList:any[] = [];
        let normalList:any[] = [];
        _.forEach(this.cols, c => {
            if (c.alwaysCheck) {
                alwaysCheckedList.push(c);
            } else {
                normalList.push(c);
            }
        });
        return alwaysCheckedList.concat(normalList);
    }

    get lsName() {
        if (!this.name) {
            return "";
        }
        return `filterCols_${this.name}`;
    }

    @Watch("checkedKeys", {
        deep: true
    })
    checkedKeysWatcher() {
        if (!this.lsName) {
            return;
        }
        // this.autoScaleTableColumnSize();
        if (this.checkedKeys.length === 0) {
            // localStorage.removeItem(this.lsName)
            return;
        }
        let storeData = JSON.stringify(this.checkedKeys);
        // console.log(storeData, 1)
        // console.log(this.lsName, storeData, 3)
        localStorage.setItem(this.lsName, storeData);
        // localStorage[this.lsName] = JSON.stringify(this.checkedKeys)
    }

    @Watch("cols", {
        deep: true
    })
    colsWatcher() {
        this.initCheckedKeys();
    }
    initCheckedKeys() {
        let checkedKeys = _.cloneDeep(this.checkedKeys);
        // console.log(checkedKeys, this.cols, 3)
        let init = checkedKeys.length === 0;
        _.forEach(this.cols, (item, key) => {
            if (!_.includes(checkedKeys, key)) {
                if (item.alwaysCheck) {
                    checkedKeys.push(key);
                } else if (item.defaultCheck && init) {
                    checkedKeys.push(key);
                }
            }
        });
        // console.log(checkedKeys, 4)
        this.checkedKeys = checkedKeys;
    }

    public init() {}

    public shouldShow(key: string) {
        // console.log(1111)
        if (!this.checkedKeys || this.checkedKeys.length === 0) {
            return true;
        }
        return _.includes(this.checkedKeys, key);
    }

    getItemTooltip(item:any) {
        return item.alwaysCheck ? this.$trans(`此列必须显示`) : '';
    }

    initFromLocalStorage() {
        let checkedKeys: string[] = [];
        let checkedKeysInLS: string | null = localStorage.getItem(this.lsName);
        if (checkedKeysInLS) {
            try {
                checkedKeys = JSON.parse(checkedKeysInLS);
            } catch (e) {}
        }
        this.checkedKeys = checkedKeys;
    }

    _toggleSelectAll(c: any, checked: boolean) {
        if (checked) {
            this.checkedKeys = _.map(this.cols, c => c.key);
        } else {
            let keys: string[] = [];
            _.forEach(this.cols, c => {
                if (c.alwaysCheck) {
                    keys.push(c.key);
                }
            });
            this.checkedKeys = keys;
        }
    }

    mounted() {
        this.initFromLocalStorage();
        this.initCheckedKeys();
    }
}
